function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11 2a1 1 0 0 0-1 1v8H6.5a.5.5 0 0 0-.5.5.5.5 0 0 0 .146.354.5.5 0 0 0 .032.029l5.105 4.814.033.032A1 1 0 0 0 12 17a1 1 0 0 0 .684-.271l.013-.012a1 1 0 0 0 .01-.012l5.104-4.812a.5.5 0 0 0 .029-.028l.008-.006a.5.5 0 0 0 .006-.005A.5.5 0 0 0 18 11.5a.5.5 0 0 0-.5-.5H14V3a1 1 0 0 0-1-1h-2zM3 20a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3z",
    style: {
      fill: "#444b54",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.a196067e6c92398b6892b4214eece6d4.svg";
export { ForwardRef as ReactComponent };